import React from 'react';
import './index.less';

import TablePropTypes from '../../prop-types';

import TableHeadItem from '../TableHeadItem';
import TableHeadItemSticky from '../TableHeadItemSticky';

class TableHead extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isVisibleStickyHeader: false
		};

		this.bindTheadRef = this.bindTheadRef.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
	}

	setInitialTheadHeight() {
		this.height = this.theadRef.getBoundingClientRect().height;
	}

	componentDidMount() {
		this.setInitialTheadHeight();

		window.addEventListener('scroll', this.handleScroll);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	bindTheadRef(e) {
		this.theadRef = e;
	}

	handleScroll() {
		/* warning!
		 * for simplification, the initial thead height is used.
		 * If the thead height changes dynamically,
		 * then these calculations will not work correctly.
		 */
		const topOffset = this.theadRef.getBoundingClientRect().top;
		this.setState({ isVisibleStickyHeader: topOffset < -this.height });
	}

	render() {
		const { headers, renderTH } = this.props;

		return (
			<thead
				className='new-table__head font-roboto-medium'
				ref={this.bindTheadRef}
			>
				{headers.map((items, i) => (
					<TableHeadItem
						items={items}
						renderTH={renderTH}
						key={i}
					/>
				))}
				<TableHeadItemSticky
					visible={this.state.isVisibleStickyHeader}
					headers={headers}
					renderTH={renderTH}
				/>
			</thead>
		);
	}
}

TableHead.propTypes = {
	headers: TablePropTypes.HeadersPropType,
	renderTH: TablePropTypes.RenderPropType
};

export default TableHead;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-table/components/TableHead/index.js